import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  UsersIcon,
  DocumentDuplicateIcon,
  HomeIcon,
  ListBulletIcon,
} from "@heroicons/react/24/outline";
import LidapLogo from "../../token/logo-lidap-horizontal";
import PopUpMenu from "./PopUpMenu";
import { EllipsisVerticalIcon } from "@heroicons/react/24/solid";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../../utils/firebase";
import "../../../assets/css/Menu.css";

export default function Menu() {
  const [isCardDisplayed, setIsCardDisplayed] = useState(false);
  const PopUpMenuRef = useRef();
  const menuBottomRef = useRef();
  const location = useLocation();
  const [user, loading] = useAuthState(auth);

  const hideMenuRoutes = ["/login", "/signup", "/mail/:id/verification"];
  const hideMenu = hideMenuRoutes.some((route) =>
    location.pathname.includes(route.replace("/:id", ""))
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        PopUpMenuRef.current &&
        !PopUpMenuRef.current.contains(event.target) &&
        !menuBottomRef.current.contains(event.target)
      ) {
        setIsCardDisplayed(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (hideMenu || loading || !user) {
    return null;
  }

  const firstName = user.displayName?.split(" ")[0] || "Utilisateur";
  const lastName = user.displayName?.split(" ")[1] || "";
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

  return (
    <div className="flex flex-col h-screen bg-neutral-100 border-r border-gray-300 w-64 select-none">
      <div className="px-4 py-8">
        <div className="border-b border-gray-300" id="wrap-menu-logo">
          <Link to="/" id="wrap-logo-lidap">
            <LidapLogo
              alt="logo de Lidap"
              className="text-gray-900"
              maxWidth="6rem"
              height="100%"
            />
          </Link>
        </div>
        <nav id="NavMenuPart">
          <div id="MenuOverview">
            <p className="mt-8 text-xs text-gray-400">Vue d'ensemble</p>
            <NavLink
              to="/home"
              className={({ isActive }) =>
                isActive
                  ? "text-sm flex gap-2 items-center text-red-500"
                  : "text-sm flex gap-2 items-center text-gray-500"
              }
            >
              <HomeIcon className="h-5 w-5" />
              Tableau de bord
            </NavLink>
            <NavLink
              to="/clients"
              className={({ isActive }) =>
                isActive
                  ? "text-sm flex gap-2 items-center text-red-500"
                  : "text-sm flex gap-2 items-center text-gray-500"
              }
            >
              <UsersIcon className="h-5 w-5" />
              Clients
            </NavLink>
            <NavLink
              to="/documents"
              className={({ isActive }) =>
                isActive
                  ? "text-sm flex gap-2 items-center text-red-500"
                  : "text-sm flex gap-2 items-center text-gray-500"
              }
            >
              <DocumentDuplicateIcon className="h-5 w-5" />
              Documents
            </NavLink>
            <NavLink
              to="/articles"
              className={({ isActive }) =>
                isActive
                  ? "text-sm flex gap-2 items-center text-red-500"
                  : "text-sm flex gap-2 items-center text-gray-500"
              }
            >
              <ListBulletIcon className="h-5 w-5" />
              Mes services
            </NavLink>
          </div>
        </nav>
      </div>

      <PopUpMenu
        isCardDisplayed={isCardDisplayed}
        PopUpMenuRef={PopUpMenuRef}
      />

      <div
        className="flex justify-center items-center w-full mt-auto cursor-pointer px-2 py-4"
        id="MenuBottom"
        onClick={() => setIsCardDisplayed(!isCardDisplayed)}
        ref={menuBottomRef}
      >
        <div className="flex justify-between items-center w-full min-w-[10vw] px-2 py-2 ring-1 ring-inset ring-gray-300 rounded-lg shadow-sm bg-white hover:bg-gray-50 gap-4">
          <div className="flex items-center gap-3">
            <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center text-xs font-semibold text-gray-600">
              {initials}
            </div>
            <div className="flex flex-col items-start">
              <p className="text-sm text-gray-700">
                {firstName} {lastName}
              </p>
              <p className="text-xs text-gray-400">Lidap</p>
            </div>
          </div>
          <EllipsisVerticalIcon className="h-6 w-6 text-gray-500" />
        </div>
      </div>
    </div>
  );
}
